import { observer } from "mobx-react-lite";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, UncontrolledTooltip } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { IScreenStatus } from "../../app/models/screens";
import { RootStoreContext } from "../../app/stores/rootStore";
import GenericModal from "../common/GenericModal";
import LabelEditingModal from "./LabelEditingModal";

interface IParams {
  screen: IScreenStatus;
}

export const LabelEditingButton: React.FC<IParams> = ({ screen }) => {
  const rootStore = useContext(RootStoreContext);
  const { changeScreenConnectionLabel } = rootStore.screensStore;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [labelValue, setLabelValue] = useState("");
  const [t] = useTranslation(["browse_page", "translation"], translationHookOptions);

  return (
    <>
      <Button
        id={`lnkEditLbl_${screen.id}`}
        color="none"
        onClick={() => setIsModalOpen(true)}
        className="screenListButton"
      >
        <i className="fas fa-edit fa-2x text-default iconBoxList"></i>
      </Button>
      <UncontrolledTooltip
        delay={0}
        placement="left"
        target={`lnkEditLbl_${screen.id}`}
      >
        {t("screens_modal_table_label_edit")}
      </UncontrolledTooltip>
      <GenericModal
        title={t("screens_modal_table_label_title")}
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(!isModalOpen)}
        content={
          <>
            <LabelEditingModal screen={screen} onLabelChange={setLabelValue} />
          </>
        }
        actions={[
          {
            text: t("save", { ns : "translation"}),
            action: async () => {
              if (screen) {
                await changeScreenConnectionLabel(screen.id, labelValue);
                setLabelValue("");
              }
            },
          },
        ]}
        cancelBtn={true}
        size="sm"
      />
    </>
  );
};

export default observer(LabelEditingButton);
